export const ejecutarSinDuplicados = async (bloqueo, operacion) => {
  if (bloqueo.current) return false;
  bloqueo.current = true;
  try {
    await operacion();
    return true;
  } finally {
    bloqueo.current = false;
  }
};
